import React from "react";

import {
  getAnalyticsCrossMPProductCostsIncome,
  updateAnalyticsCrossMPProductCostsIncome,
} from "root/api/analytics/cross-mp/product_cost_income";
import { getAnalyticsCrossMPProductCostsIncomeExport } from "root/api/analytics/cross-mp/product_cost_income/export";
import { uploadIncomeCostCrossMP } from "root/api/analytics/cross-mp/product_cost_income/upload_income_cost";
import {
  getAnalyticsCrossMPProductCostsV3,
  updateAnalyticsCrossMPProductCostsV3,
} from "root/api/analytics/cross-mp/product_cost_v3";
import { getAnalyticsCrossMPProductCostsDefaultExport } from "root/api/analytics/cross-mp/product_cost_v3/export";
import { uploadDefaultCostCrossMP } from "root/api/analytics/cross-mp/product_cost_v3/upload_default_cost";

import Ozon from "root/icons/Ozon";
import WB from "root/icons/WB";

export const marketplaces = [
  { id: "wb", icon: <WB /> },
  //Озон фронтово тоже уже готов, решили пока скрыть, будет логика меняться
  // { id: "ozon", icon: <Ozon /> },
  // { id: "yandex", icon: <YM /> },
];
// --------------------------------------------------------------------------------------
export const costPriceTabs = [
  {
    id: "default",
    label: "Себестоимость по умолчанию",
    apiFuncName: getAnalyticsCrossMPProductCostsV3,
    exportApi: getAnalyticsCrossMPProductCostsDefaultExport,
    uploadApi: uploadDefaultCostCrossMP,
    updateValueApi: updateAnalyticsCrossMPProductCostsV3,
    articleSelectorApi: "useGetItemsCrossMPQuery",
    selectorsApi: "getItemsCrossMP",
  },
  {
    id: "by_deliveries",
    label: "Себестоимость по поставкам",
    apiFuncName: getAnalyticsCrossMPProductCostsIncome,
    exportApi: getAnalyticsCrossMPProductCostsIncomeExport,
    uploadApi: uploadIncomeCostCrossMP,
    updateValueApi: updateAnalyticsCrossMPProductCostsIncome,
    articleSelectorApi: "useGetCostSelectorItemsCrossMPQuery",
    selectorsApi: "getCostSelectorItemsCrossMP",
  },
];

export const tableTabs = [
  {
    id: "all",
    label: "Все строки",
    product_cost__isnull: undefined,
  },
  {
    id: "isnull_only",
    label: "Только незаполненные строки",
    product_cost__isnull: true,
  },
];
// --------------------------------------------------------------------------------------
const isPercentField = fieldName => {
  return fieldName.includes("_nds");
};

export const toServerValue = (value, fieldName) => {
  return isPercentField(fieldName) ? value / 100 : value;
};

const safeMultiply = (value, multiplier = 100) => {
  return value != null ? value * multiplier : null;
};

export const transformData = (data, cabinet_id) =>
  data.map(item => ({
    ...item,
    product: {
      id: item.product_id,
      name: item.product_name,
      image: item.product_image,
    },
    cost_data: {
      value: item.cost,
      mp_item_id: item.mp_item_id,
      cabinet_id,
      supply_id: item.supply_id,
      marketplace: item.marketplace,
      date: item.date,
      otherValues: {
        cost_nds: safeMultiply(item.cost_nds),
        fulfillment: item.fulfillment,
        fulfillment_nds: safeMultiply(item.fulfillment_nds),
        output_nds: safeMultiply(item.output_nds),
      },
    },
    cost_nds_data: {
      value: safeMultiply(item.cost_nds),
      mp_item_id: item.mp_item_id,
      cabinet_id,
      supply_id: item.supply_id,
      marketplace: item.marketplace,
      date: item.date,
      otherValues: {
        cost: item.cost,
        fulfillment: item.fulfillment,
        fulfillment_nds: safeMultiply(item.fulfillment_nds),
        output_nds: safeMultiply(item.output_nds),
      },
    },
    fulfillment_data: {
      value: item.fulfillment,
      mp_item_id: item.mp_item_id,
      cabinet_id,
      supply_id: item.supply_id,
      marketplace: item.marketplace,
      date: item.date,
      otherValues: {
        cost_nds: safeMultiply(item.cost_nds),
        cost: item.cost,
        fulfillment_nds: safeMultiply(item.fulfillment_nds),
        output_nds: safeMultiply(item.output_nds),
      },
    },
    fulfillment_nds_data: {
      value: safeMultiply(item.fulfillment_nds),
      mp_item_id: item.mp_item_id,
      cabinet_id,
      supply_id: item.supply_id,
      marketplace: item.marketplace,
      date: item.date,
      otherValues: {
        cost_nds: safeMultiply(item.cost_nds),
        cost: item.cost,
        fulfillment: item.fulfillment,
        output_nds: safeMultiply(item.output_nds),
      },
    },
    output_nds_data: {
      value: safeMultiply(item.output_nds),
      mp_item_id: item.mp_item_id,
      cabinet_id,
      supply_id: item.supply_id,
      marketplace: item.marketplace,
      date: item.date,
      otherValues: {
        cost_nds: safeMultiply(item.cost_nds),
        cost: item.cost,
        fulfillment: item.fulfillment,
        fulfillment_nds: safeMultiply(item.fulfillment_nds),
      },
    },
  }));
